/**
 * フォームの情報
 */

const headList: any[] = [
  {
    headTitle: "職員名",
  },
  {
    headTitle: "性別",
  },
  {
    headTitle: "生年月日",
  },
  {
    headTitle: "加入年月日",
  },
];

const stepperData = ["届出待ち", "承認中", "完了"];
export { headList, stepperData };
